import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { RequestResponse } from '@/types';
import type { NotificationSettingsPayload } from './payload';
import type { NotificationSettingsData } from './response';

export const updateNotificationSettings = async (
  payload: NotificationSettingsPayload
) => {
  const response = await axiosInstance.post<
    RequestResponse<NotificationSettingsData>
  >(endpoints.notificationSettings, payload);
  return response.data;
};

export const markNotificationAsRead = async (id: number) => {
  const response = await axiosInstance.patch<RequestResponse<null>>(
    `${endpoints.notifications}/${id}/read`
  );
  return response.data;
};

export const markAllNotificationsAsRead = async () => {
  const response = await axiosInstance.patch<RequestResponse<null>>(
    endpoints.notificationReadAll
  );
  return response.data;
};
